import script from "./LBTabMainHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./LBTabMainHeader.vue?vue&type=script&setup=true&lang=js"

import "./LBTabMainHeader.vue?vue&type=style&index=0&id=310e85dc&scoped=true&lang=css"

import exportComponent from "/Users/learnbody/Documents/VSWorkspaces/learnbody-market-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-310e85dc"]])

export default __exports__